export const FlashMessage = {
  mounted() {
    this._mounted = true;

    // Fade in using Tailwind classes
    this._fadeInTimeout = setTimeout(() => {
      if (!this._mounted) return;
      this.el.classList.remove("opacity-0", "-translate-y-2");
      this.el.classList.add("opacity-100", "translate-y-0");
    }, 10);

    // Auto-hide after 2 seconds
    this._hideTimeout = setTimeout(() => {
      if (!this._mounted) return;
      const kind = this.el.dataset.kind;
      this.el.classList.remove("opacity-100", "translate-y-0");
      this.el.classList.add("opacity-0", "-translate-y-2");

      // Clear flash after fade out completes
      this._clearTimeout = setTimeout(() => {
        if (!this._mounted) return;
        // pushEvent returns a Promise that rejects when LiveView isn't
        // connected — try/catch alone doesn't catch async rejections.
        try {
          const result = this.pushEvent("lv:clear-flash", { key: kind });
          if (result && typeof result.catch === "function") {
            result.catch(() => {});
          }
        } catch (_e) {
          // Silently fail if LiveView is disconnected
        }
      }, 300);
    }, 2500);
  },

  destroyed() {
    this._mounted = false;
    clearTimeout(this._fadeInTimeout);
    clearTimeout(this._hideTimeout);
    clearTimeout(this._clearTimeout);
  },
};
